// Library Methods
import React from "react";
import { useLocation } from "react-router-dom";

// Components
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

// Styles
import { getSurfaceTokens } from "src/styles/mui/muiStylesHelper";

type OperatingManualNavButtonsType = {
  navbarOptions: Array<{
    route: string;
    label: string;
    subRoutes?: Array<{ route: string; label: string }>;
  }>;
  handleSelectNavbarOption: (option: {
    route: string;
    label: string;
    subRoutes?: Array<{ route: string; label: string }>;
  }) => void;
  handleSelectSubRoute: (
    option: {
      route: string;
      label: string;
    },
    subOption: {
      route: string;
      label: string;
    }
  ) => void;
  onSelectCallback?: () => void;
};

const OperatingManualNavButtons = ({
  navbarOptions,
  handleSelectNavbarOption,
  handleSelectSubRoute,
  onSelectCallback,
}: OperatingManualNavButtonsType) => {
  const location = useLocation();
  const theme = useTheme();
  const { onSurface } = getSurfaceTokens(theme);
  // The translucent #5B6D7A35 barely registers against the sidebar's own
  // dark-mode background -- reuse FilterSection's item-row color instead
  // (darker than the sidebar's own #4D5063, so it reads as a clear, opaque
  // contrast rather than a near-invisible tint).
  const isDark = theme.palette.mode === "dark";
  const selectedBackground = isDark ? "#35394F" : "#5B6D7A35";

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
      {navbarOptions.map((navbarOption) => {
        const isSelected =
          location.pathname ===
          `/knowledge-hub/operating-manual/${navbarOption.route}`;

        return (
          <React.Fragment key={navbarOption.label}>
            <Button
              onClick={() => {
                handleSelectNavbarOption(navbarOption);
                onSelectCallback?.();
              }}
              sx={{
                padding: "8px",
                textTransform: "none",
                color: onSurface,
                width: "100%",
                backgroundColor: isSelected
                  ? selectedBackground
                  : "transparent",
                justifyContent: "left",

                "&:hover": {
                  backgroundColor: selectedBackground,
                },
              }}
            >
              <Typography fontSize="14px" fontWeight={600} textAlign="left">
                {navbarOption.label}
              </Typography>
            </Button>

            {navbarOption.subRoutes?.map((subRoute) => {
              const isSelected =
                location.pathname ===
                `/knowledge-hub/operating-manual/${navbarOption.route}/${subRoute.route}`;

              return (
                <Button
                  key={subRoute.label}
                  onClick={() => {
                    handleSelectSubRoute(navbarOption, subRoute);
                    onSelectCallback?.();
                  }}
                  sx={{
                    padding: "8px 20px",
                    textTransform: "none",
                    color: onSurface,
                    width: "100%",
                    backgroundColor: isSelected
                      ? selectedBackground
                      : "transparent",
                    justifyContent: "left",

                    "&:hover": {
                      backgroundColor: selectedBackground,
                    },
                  }}
                >
                  <Typography fontSize="14px" textAlign="left">
                    {subRoute.label}
                  </Typography>
                </Button>
              );
            })}
          </React.Fragment>
        );
      })}
    </Box>
  );
};

export default OperatingManualNavButtons;
